import React from 'react';

const DoughnutLabelComponent = props => {
  const { color, label } = props;
  return (
    <div className="labels-container__item">
      <div
        className="labels-container__item__square"
        style={{ backgroundColor: color }}>
        <div className="labels-container__item__square__dot" />
      </div>
      <div>{label}</div>
    </div>
  );
};

export default DoughnutLabelComponent;



// WEBPACK FOOTER //
// ./src/components/DoughnutLabelComponent/DoughnutLabelComponent.js